import React, { useState } from 'react';
import './Sponsors.css';
import Navbar from './Navbar';
import Footer from './Footer';

const SponsorsSection = () => {
  const [imageError, setImageError] = useState({});

  const sponsors = [
    {
      name: 'RESCONS Solutions Pvt. Limited',
      location: 'Bengaluru, India - 560012',
      website: 'https://www.rescons.in',
      imageUrl:
        'https://raw.githubusercontent.com/kmranimesh/Web-dev-toolkit/main/rescons_logo%20.jpg',
    },
    {
      name: 'Another Sponsor Pvt. Ltd.',
      location: 'Mumbai, India - 400001',
      website: 'https://www.example.com',
      imageUrl:
        'https://via.placeholder.com/200x100.png?text=Another+Sponsor+Logo',
    },
    // 👉 Add more sponsors here
  ];

  // handle per-sponsor image errors
  const handleImageError = (index) => {
    setImageError((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <>
      <Navbar />
      <div className="sponsors-wrapper">
        {/* Header */}
        <div className="sponsors-header">
          <h1>Our Esteemed Sponsors</h1>
          <p>
            We proudly partner with industry leaders to promote innovation and
            visibility.
          </p>
        </div>

        {/* Sponsor Cards */}
        <div className="sponsor-cards-row">
          {sponsors.map((sponsor, index) => (
            <div key={index} className="sponsor-card">
              {!imageError[index] ? (
                <div className="sponsor-logo">
                  <img
                    src={sponsor.imageUrl}
                    alt={`${sponsor.name} Logo`}
                    onError={() => handleImageError(index)}
                  />
                </div>
              ) : (
                <div className="fallback-image">
                  <p>{sponsor.name}</p>
                </div>
              )}
              <div className="sponsor-details">
                <h3>{sponsor.name}</h3>
                <p className="sponsor-location">{sponsor.location}</p>
                <a
                  href={sponsor.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="visit-button"
                >
                  Visit Website →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      <br />
      <br />
      <Footer />
    </>
  );
};

export default SponsorsSection;
